export var stylePrefix = 'formily-vant';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vant/esm/__builtins__/configs/index.js
// module id = null
// module chunks = 